
export default function isEmptyArray<T>(list: Array<T>): boolean {
  return list.length === 0
}